"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var pintuanApi = _interopRequireWildcard(require("@/api/pintuanApi"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      visible: false,
      pram: {},
      initloading: false,
      spuLists: [{
        id: 1
      }, {
        id: 2
      }, {
        id: 3
      }]
    };
  },
  mounted: function mounted() {},
  methods: {
    throttle: _throttle.default,
    openInit: function openInit() {
      this.getSupLists();
      this.pram = {};
      this.visible = true;
    },
    getSupLists: function getSupLists(spuName) {
      var _this = this;
      this.spuLists = [];
      this.initloading = true;
      pintuanApi.getSpuListss(spuName).then(function (res) {
        _this.spuLists = (res === null || res === void 0 ? void 0 : res.list) || [];
        _this.initloading = false;
      }).catch(function (err) {
        _this.initloading = false;
      });
    },
    handleSpuSearch: function handleSpuSearch(data) {
      var _this2 = this;
      this.throttle(function () {
        _this2.getSupLists(data);
      }, 300)();
    },
    handerSubmit: function handerSubmit() {
      var _this$pram,
        _this$pram2,
        _this3 = this;
      if (!((_this$pram = this.pram) !== null && _this$pram !== void 0 && _this$pram.spuId)) {
        this.$message.warning('请选择商品！');
        return;
      }
      ;
      pintuanApi.initPinGoods((_this$pram2 = this.pram) === null || _this$pram2 === void 0 ? void 0 : _this$pram2.spuId).then(function (res) {
        var _this3$pram;
        _this3.$router.push({
          path: "/store/list/creatPintuan/0/0/".concat((_this3$pram = _this3.pram) === null || _this3$pram === void 0 ? void 0 : _this3$pram.spuId)
        });
      });
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    }
  }
};